import { common as enCommon } from './en/common';
import { common as esCommon } from './es/common';

export default {
  en: {
    common: enCommon
  },
  es: {
    common: esCommon
  }
};